// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import LaborRateHistory, {getDefaultState as getLaborRateHistoryDefaultState} from './report';
import ReportIsScrollable, {getDefaultState as getReportIsScrollableDefaultState} from '../../shared/state/report-is-scrollable';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    historyToDisplay: t.maybe(t.Number),
    report: LaborRateHistory,
    reportIsScrollable: ReportIsScrollable,
    showNoResultsFound: t.Boolean
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        historyToDisplay: 90,
        report: getLaborRateHistoryDefaultState(),
        reportIsScrollable: getReportIsScrollableDefaultState(),
        showNoResultsFound: false
    });

export default State;



// WEBPACK FOOTER //
// ./src/reports/labor-rate-history/state/index.js